import {Component} from '@angular/core';
import {FeatureTypeService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {Feature} from '@catcore/services/feature/feature';
import {DefaultLanding} from '@catfeatures/shared/default-landing';

const EntitySchemaTypeRef = 'FeatureGgwDevices';
const selfTitle = 'Feature Ggw Devices';

@Component({
  templateUrl: './feature-ggw-devices-landing.component.html',
})
export class FeatureGgwDevicesLandingComponent extends DefaultLanding {

  constructor(schemaService: EntitySchemaService,
              featureService: FeatureTypeService) {
    super(schemaService, featureService);
    this.setSelfTitle(selfTitle);
  }

  getEntitySchemaTypeRef() {
    return EntitySchemaTypeRef;
  }

  getRelatedItems(feature: Feature) {
    return this.getFeatureService().extractGgwDevicesFor(feature);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-ggw-devices-landing/feature-ggw-devices-landing.component.ts